import { ContactDetailsSession } from './contactDetailsSession';
import { CreatePickUpSession } from './CreatePIckUpSession';
import { LocationDetailsSession } from './locationDetailsSession';
import { NotificationDetailsSession } from './notificationDetailsSession';
import { PickupDetailsSession } from './pickupDetailsSession';
import { PlacardConfirmationSession } from './placardConfirmationSession';
import { PlacardDetailsSession } from './placardDetailsSession';
import { PlacardLocationSession } from './PlacardLocationSession';

export class SessionRequest {
    key: string;
    placardStatus: string;
    locationDetails: LocationDetailsSession;
    temporaryLocation: LocationDetailsSession;
    contactDetails: ContactDetailsSession;
    placardDetails: PlacardDetailsSession;
    pickupDetails: PickupDetailsSession;
    notificationDetails: NotificationDetailsSession;
    createPickUp: CreatePickUpSession;
    lastTimeSessionReqired: string;    
    placardConfirmation: PlacardConfirmationSession;
    placardLocation: PlacardLocationSession;
    comesFromReview: boolean;
    backBrowserPage: string;
    placardID: string;
    isApproved: boolean;
}